$(() => {
  const $newsMentionsPlaceholder = $(".js-news-mentions");

  if (!$newsMentionsPlaceholder.length) return;

  $.ajax({
    url: "/api/intranet-news-mentions/",
    success: function(data) {
      if (!!data) $newsMentionsPlaceholder.html(data);
    }
  });
});
